const BREADCRUMB_MAP = {
    HOME_PAGE: { name: "Home", href: "/home" },
    INFORMATIVA_PRIVACY: { name: "Informativa Privacy", href: "" },
    COOKIE: { name: "Cookie", href: "" },
    ACCESSIBILITA: { name: "Accessibilità", href: "" },
    ARCHIVIO_RSSR: { name: "Archivio", href: "" }

};

const BREADCRUMB_INFORMATIVA_PRIVACY = [
    BREADCRUMB_MAP.HOME_PAGE,
    BREADCRUMB_MAP.INFORMATIVA_PRIVACY
];

const BREADCRUMB_COOKIE = [
    BREADCRUMB_MAP.HOME_PAGE,
    BREADCRUMB_MAP.COOKIE
];

const BREADCRUMB_ACCESSIBILITA = [
    BREADCRUMB_MAP.HOME_PAGE,
    BREADCRUMB_MAP.ACCESSIBILITA
];

const BREADCRUMB_ARCHIVIO_RSSR = [
    BREADCRUMB_MAP.HOME_PAGE,
    BREADCRUMB_MAP.ARCHIVIO_RSSR
];




export {
    BREADCRUMB_INFORMATIVA_PRIVACY,
    BREADCRUMB_MAP,
    BREADCRUMB_COOKIE,
    BREADCRUMB_ACCESSIBILITA,
    BREADCRUMB_ARCHIVIO_RSSR
};